import React from 'react';
import { styled } from 'components';
import { qaAttr } from 'utils';
import { BrandLogo } from 'assets';

const { LANDING_ORIGIN } = process.env;

const StyledLink = styled('a')(({ theme }) => ({
  fontSize: 18,
  fontWeight: 'bold',
  letterSpacing: -0.08,
  lineHeight: '20px',
  textAlign: 'center',
  color: theme.palette.common.white
}));

const LogoLink = (props) => (
    <StyledLink
      href={LANDING_ORIGIN}
      className="logoLink"
      {...qaAttr('landing-home-link')}
      {...props}
    >
      <BrandLogo />
    </StyledLink>
  )

export default LogoLink;
